export default __webpack_public_path__ + "static/media/July2021.f72113ae.png";